import { Button, Card, notification, Space } from 'antd';
import Title from 'antd/es/typography/Title';
import ActividadesTable from 'components/tables/ActividadesTable';
import useRequest from 'hooks/useRequest';
import { useActividades } from 'providers/ActividadProvider';
import { useColeccion } from 'providers/ColeccionProvider';
import { usePlantillaTexto } from 'providers/PlantillasTextoProvider';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import useTenantFlags from 'hooks/useTenantFlags';
import { ImportExportToolbar } from 'components/global/ImportExport';
import { ACTIVIDAD_COLUMNS } from 'components/global/ImportExport/actividadColumns';

const ACTIVIDADES_IE_CONFIG = {
  exportUrl: (scope, format) =>
    scope.level === 'item'
      ? `/colecciones/items/${scope.itemId}/actividades/export?format=${format}`
      : `/colecciones/${scope.idColeccion}/actividades/export?format=${format}`,
  validateUrl: '/colecciones/actividades/import/validate',
  commitUrl: '/colecciones/actividades/import/commit',
};

const ActividadesComponent = ({
  openAdd,
  openEdit,
  openDelete,
  itemId,
  item,
  openImport,
  getItem,
}) => {
  const { readOnly } = useTenantFlags();
  return (
    <Space direction="vertical" className="w-full">
      <Card className="welcome col-span-3">
        <div className="flex flex-row justify-between">
          <Title level={3} className="text-start">
            <span className="uppercase text-white">Ítems de la Colección</span>
          </Title>
          {!readOnly && (
            <Button onClick={() => openImport(getItem)} type="default" icon={<PlusOutlined />}>
              Importar
            </Button>
          )}
          {!readOnly && (
            <ImportExportToolbar
              scope={{ level: 'item', itemId: Number(itemId) }}
              columns={ACTIVIDAD_COLUMNS}
              config={ACTIVIDADES_IE_CONFIG}
              humanName="actividades"
              onCommitSuccess={getItem}
            />
          )}
          {!readOnly && (
            <Button
              type="primary"
              className="mb-4"
              onClick={() => openAdd(null, true, itemId, getItem)}
            >
              Agregar Item
            </Button>
          )}
        </div>
      </Card>
      <ActividadesTable
        data={item?.Actividades}
        openEdit={(values) => openEdit(values, getItem)}
        openDelete={(id) => openDelete(id, null, getItem)}
      />
    </Space>
  );
};

const ItemsColeccionPage = () => {
  const { id, itemId } = useParams();
  const location = useLocation();
  const [current, setCurrent] = useState();

  const { openAdd, openEdit, openDelete, openImport } = useActividades();

  const [item, setItem] = useState({});

  const { request, isLoadingReq, errors } = useRequest();
  const getItem = useCallback(async () => {
    try {
      const result = await request(`/colecciones/items/${itemId}`, 'GET');
      setItem(result);
      return result;
    } catch (error) {
      notification.error({
        message: 'Error al cargar el ítem',
        description: error.message,
      });
    }
  }, [request, itemId]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');
    if (type) {
      setCurrent(type);
    }
  }, [location.search]);

  useEffect(() => {
    getItem();
  }, [getItem]);

  const renderComponent = () => {
    switch (current) {
      case 'ACTIVIDADES':
        return (
          <ActividadesComponent
            openAdd={openAdd}
            openEdit={openEdit}
            openDelete={openDelete}
            openImport={(refresh) => openImport(id, refresh)}
            itemId={itemId}
            item={item}
            getItem={getItem}
          />
        );
      case 'comprobantes':
        return <div>Comprobantes</div>;
      default:
        return <div>Error</div>;
    }
  };

  return renderComponent();
};

export default ItemsColeccionPage;
